import { FC } from 'react';

import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getSetIsOpenFullScreenTable } from 'store/useBusinessToolStore/selectors';

import { FullScreenModal } from 'components/_basic/FullScreenModal';
import { FullScreenButton } from 'components/FullScreenButton/FullScreenButton';
import { useModalState } from 'components/ModalManager/useModalState';

import { IFullScreenWrapperProps } from './types';

export const FullScreenWrapper: FC<IFullScreenWrapperProps> = ({ children, disabled, title = '' }) => {
  const { open, handleOpen, handleClose } = useModalState();
  const setIsOpenFullScreenTable = useBusinessToolStore(getSetIsOpenFullScreenTable);

  const handleOpenFullScreenTable = () => {
    setIsOpenFullScreenTable(true);
    handleOpen();
  };
  const handleCloseFullScreenTable = () => {
    setIsOpenFullScreenTable(false);
    handleClose();
  };

  return (
    <>
      {!open && children}

      <FullScreenButton onClick={handleOpenFullScreenTable} disabled={disabled} />
      {open && <FullScreenModal title={title} body={children} close={handleCloseFullScreenTable} />}
    </>
  );
};
